@if (results.length) {
  <section class="histogram">
    <div class="histogram-head">
      <div>
        <h3>Score distribution</h3>
        <p>Number of evaluation results in each score range.</p>
      </div>
      <mat-form-field appearance="outline"
        ><mat-label>Metric</mat-label
        ><mat-select [(ngModel)]="metric"
          ><mat-option value="">All metrics</mat-option>
          @for (item of metrics; track item) {
            <mat-option [value]="item">{{ item }}</mat-option>
          }
        </mat-select></mat-form-field
      >
    </div>
    <div class="chart" aria-label="Evaluation score histogram">
      @for (bin of bins; track bin.label) {
        <div class="bar-group">
          <div class="value">{{ bin.count }}</div>
          <div
            class="bar"
            [style.height.%]="(bin.count / maxCount()) * 100"
          ></div>
          <small>{{ bin.label }}</small>
        </div>
      }
    </div>
  </section>
}
